<template>
  <BaseModal
    :is-visible="isVisible"
    :is-archivable="false"
    :is-editable="false"
    size="lg"
    @hideModal="hideModal()"
  >
    <template #header>
      {{$t('views.promotions.update.title')}}
    </template>
    <template #body>
      <Form></Form>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/BaseComponents/BaseModal'
import Form from './Form'
import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
  name: 'UpdateModal',
  components: {
    BaseModal,
    Form
  },
  props: {
    iri: {
      type: String,
      required: true
    }
  },
  created () {
    this.retrieve(this.iri)
  },
  watch: {
    updated () {
      this.reset()
      this.toggleUpdateModal()
    }
  },
  computed: {
    ...mapGetters({
      isVisible: 'promotions/getIsUpdateModalVisible',
      updated: 'promotions/getUpdated'
    })
  },
  methods: {
    hideModal () {
      this.reset()
      this.toggleUpdateModal()
    },
    ...mapMutations({
      reset: 'promotions/reset',
      toggleUpdateModal: 'promotions/toggleUpdateModal'
    }),
    ...mapActions({
      retrieve: 'promotions/retrieve'
    })
  }
}
</script>

<style scoped>

</style>
